import { render, staticRenderFns } from "./TurnLog.vue?vue&type=template&id=9b367e96&"
import script from "./TurnLog.vue?vue&type=script&lang=js&"
export * from "./TurnLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports